import { Component, OnInit } from '@angular/core';
import { AprovacaoVeiculo } from 'src/app/model/aprovacao-veiculo.model';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize } from 'rxjs';
import { AprovacoesService } from '../aprovacoes.service';
import * as FileSaver from 'file-saver';
import { dataURItoBlobTypeZip } from 'src/app/shared/utils/file-utils';

@Component({
  selector: 'app-aprovacoes-veiculo',
  templateUrl: './aprovacoes-veiculo.component.html',
  styleUrls: ['./aprovacoes-veiculo.component.scss'],
})
export class AprovacoesVeiculoComponent implements OnInit {
  items: AprovacaoVeiculo[];
  displayDialog: boolean = false;
  oidCadastroVeiculosSelecionado: number = null;
  displayDialogMotivoReprovacao: boolean = false;
  inputData: any;

  constructor(
    private aprovacoesService: AprovacoesService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.recuperaVeiculosParaAprovacao();
  }

  private recuperaVeiculosParaAprovacao() {
    this.spinner.show();

    this.aprovacoesService
      .findVeiculosParaAprovacao()
      .pipe(
        catchError((error) => {
          console.error('Erro ao buscar veículos para aprovação:', error);
          this.messageService.add({
            severity: 'Error',
            summary: 'Erro ao recuperar veículos para aprovação',
            detail: error,
          });
          throw error;
        }),
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe((data) => {
        if (data) {
          this.items = data;
          console.log(
            'Operação de busca de veículos para aprovação concluída com sucesso.'
          );
        }
      });
  }

  public selectAll(): void {
    const selectAllCheckbox = document.getElementById(
      'checkboxSelecionarTodos'
    ) as HTMLInputElement;
    this.items.forEach((item) => (item.selected = selectAllCheckbox.checked));
  }

  public aprovarVeiculoSelecionada(oidCadastroVeiculos: number): void {
    const oidCadastroVeiculosList: number[] = [oidCadastroVeiculos];
    this.aprovar(oidCadastroVeiculosList);
  }

  public aprovarSelecionados(): void {
    const selectedItems = this.items.filter((item) => item.selected);
    if (selectedItems && selectedItems.length > 0) {
      this.spinner.show();

      console.log(selectedItems);
      const oidCadastroVeiculosList: number[] = selectedItems.map(
        (item) => item.oidCadastroVeiculos || 0
      );

      this.aprovar(oidCadastroVeiculosList);
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aprovar Veiculo',
        detail: 'Nenhuma veiculo foi selecionado para aprovação',
      });
    }
  }

  public aprovar(oidCadastroVeiculosList: number[]): void {
    this.aprovacoesService
      .aprovarVeiculo(oidCadastroVeiculosList)
      .pipe(
        catchError((error) => {
          console.error('Erro ao aprovar veículos:', error);
          this.messageService.add({
            severity: 'Error',
            summary: 'Erro ao aprovar veículos',
            detail: error,
          });
          throw error;
        }),
        finalize(() => {
          this.spinner.hide();
          this.recuperaVeiculosParaAprovacao();
        })
      )
      .subscribe((data) => {
        if (data && data > 0) {
          console.log(
            'Operação de aprovação de veículos concluída com sucesso.'
          );
        } else {
          this.messageService.add({
            severity: 'Aprovar veículos',
            summary:
              'Uma ou mais veículos não puderam ser aprovados. Verifique.',
          });
        }
      });
  }

  public removerVeiculoSelecionada(oidCadastroVeiculos: number): void {
    const oidCadastroVeiculosList: number[] = [oidCadastroVeiculos];
    //this.remover(oidCadastroVeiculosList);
    this.inputData = { oidList: oidCadastroVeiculosList };
    this.displayDialogMotivoReprovacao = true;
  }

  removerSelecionados() {
    const selectedItems = this.items.filter((item) => item.selected);
    if (selectedItems && selectedItems.length > 0) {
      //this.spinner.show();

      console.log(selectedItems);
      const oidCadastroVeiculoList: number[] = selectedItems.map(
        (item) => item.oidCadastroVeiculos || 0
      );

      //this.remover(oidCadastroVeiculoList);
      this.inputData = { oidList: oidCadastroVeiculoList };
      this.displayDialogMotivoReprovacao = true;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Remover Veiculo',
        detail: 'Nenhuma veiculo foi selecionado para remoção',
      });
    }
  }

  public remover(
    oidCadastroVeiculoList: number[],
    dsMotivoReprovacao: string
  ): void {
    this.aprovacoesService
      .reprovarVeiculo(oidCadastroVeiculoList, dsMotivoReprovacao)
      .pipe(
        catchError((error) => {
          console.error('Erro ao remover veículos:', error);
          this.messageService.add({
            severity: 'Error',
            summary: 'Erro ao remover veículos',
            detail: error,
          });
          throw error;
        }),
        finalize(() => {
          this.spinner.hide();
          this.recuperaVeiculosParaAprovacao();
        })
      )
      .subscribe((data) => {
        if (data && data > 0) {
          console.log('Operação de remoção de veículos concluída com sucesso.');
        } else {
          this.messageService.add({
            severity: 'Remover veículos',
            summary:
              'Uma ou mais veículos não puderam ser removidos. Verifique.',
          });
        }
      });
  }

  public abrirModalDeConsulta(oidCadastroVeiculo: number): void {
    this.displayDialog = true;
    this.oidCadastroVeiculosSelecionado = oidCadastroVeiculo;
  }

  public closeDialog(): void {
    this.displayDialog = false;
  }

  onDialogMotivoClose(event: any) {
    this.displayDialogMotivoReprovacao = false;

    if (event) this.remover(event.oidList, event.dsMotivoReprovacao);
  }

  baixarArquivos(oidVeiculo: number) {
    this.aprovacoesService.baixarAnexosVeiculoPorId(oidVeiculo).subscribe({
      next: (response) => {
        if (response) {
          const blob = dataURItoBlobTypeZip(response.arqBase64Bytes);
          FileSaver.saveAs(blob, `${response.nomeArquivo}`);
        }
      },
      error: (err) => console.error('Erro ao baixar arquivos do veiculo:', err),
    });
  }
}
